<template>
  <div>
    <table width="100%">
      <tr>
        <td>
          <my-header></my-header>
        </td>
      </tr>
    </table> 
      <div class="col-md-6" v-for="(item , ind) in roadmap">
        <div class="form-group" style="border-top: 3px solid #343a40;">
          <h3 style="margin-top: 10px;text-align:center"><span>Semester</span> {{item.Semester}} - {{item.DeptName}} - {{item.ProgramName}}</h3>
            <div class="table-responsive"> 
              <table width="100%" class="table table-bordered table-sm table-striped table-color " style="font-size: 12px;border-collapse: collapse;" border="1">
                <thead class="bg-info">
                  <tr style="background-color: darkgrey;">
                    <th width="10%" rowspan="2">Sr. No.</th>
                    <th width="10%" rowspan="2">Code</th>
                    <th rowspan="2">Course Name</th>
                    <th width="15%" colspan="3" style="text-align: center">Credit Hours</th>
                    <th width="70px" rowspan="2" style="text-align: center">Offer Course</th>
                  </tr>
                  <tr style="background-color: darkgrey;">
                    <th style="text-align: center">Theory</th>
                    <th style="text-align: center">Lab</th>
                    <th style="text-align: center">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item2,index) in item.Child">
                    <td align="center">{{index+1}}</td>
                    <td>{{item2.CourseCode}}</td>
                    <td>{{item2.CourseName}}</td>
                    <td style="text-align: center">{{item2.Theory}}</td>
                    <td style="text-align: center">{{item2.Lab}}</td>
                    <td style="text-align: center">{{item2.CreditHours}}</td>
                    <td style="text-align: center">{{item2.IsOffered}}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="7">
                      <span>Total Courses: {{totalCourses(ind)}}</span>
                      <span class="pull-right">Total Credit Hour: {{totalCreditHours(ind)}}</span>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div> 
        </div>
      </div> 
      <div class="col-md-12">
        <div style="border-top: 3px solid #605ca8; margin-top: 20px">
          <h4>Total Summary</h4>
          <div class="table-responsive">
            <table width="100%" class="table table-bordered table-sm  table-striped table-color" border="1" style="border-collapse: collapse;">
              <thead class="bg-info">
                <tr style="background-color: darkgrey;">
                  <th>Types</th>
                  <th>Total Number of Courses</th>
                  <th>Total Number of Credit Hours</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="check(item.CourseTypeID)" v-for="item,index in coursetype">
                  <td>{{item.Name}}</td>
                  <td align="right">{{convertsss(item.CourseTypeID)}}</td>
                  <td align="right">{{convertsss2(item.CourseTypeID)}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div> 
  </div>
</template>

<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {
        roadmap: [], coursetype: [], prog: []
      }
    },
    created: function () {
      this.loadRecord();
    },

    methods:
    {
      loadRecord() {
        var vm = this; 
        axios.post('/api/DCApi/getRoadMapData2') 
          .then(function (response) {
            vm.roadmap = response.data.lst;
            vm.coursetype = response.data.typ;
            vm.prog = response.data.prog;
          })
      },
      check(ID) {
        var count = 0;
        var vm = this;
        this.roadmap.forEach(function (r) {
          if (r.Child != null && r.Child != '') {
            r.Child.forEach(function (c) {
              if (c.CourseTypeID == ID) {
                count = count + 1;
              }
            })
          }
        })
        if (count == 0)
          return false;
        else
          return true;
      },
      totalCourses(sem) {
        if (this.roadmap[sem].Child != null && this.roadmap[sem].Child != '')
          return this.roadmap[sem].Child.length;
        else
          return 0;
      },
      totalCreditHours(sem) {
        var cr = 0;
        var vm = this;
        if (vm.roadmap[sem].Child != null && vm.roadmap[sem].Child != '') {
          vm.roadmap[sem].Child.forEach(function (item) {
            cr += Number(item.CreditHours);
          });
          return cr;
        }
        else
          return 0;
      },
      //count courses type wise
      convertsss(ID) {
        var count = 0;
        var vm = this;
        this.roadmap.forEach(function (r) {
          if (r.Child != null && r.Child != '') {
            r.Child.forEach(function (c) {
              if (c.CourseTypeID == ID) {
                count = count + 1;
              }
            })
          }
        })

        return count;
      },

      //count creidt hours type wise
      convertsss2(ID) {
        var count = 0;
        this.roadmap.forEach(function (r) {
          if (r.Child != null && r.Child != '') {
            r.Child.forEach(function (c) {
              if (c.CourseTypeID == ID) {
                count = count + Number(c.CreditHours);
              }
            })
          }
        })

        return count;
      },
    },
  })
</script>



// WEBPACK FOOTER //
// src/components/DC/RoadMapReportPrint.vue